import { useMemo } from 'react';

import { Metadata, Monitor } from '@paragon/monitoring';
import { setMonitorForNotificationTools } from '@paragon/notification-tools';
import { setMonitorForPopupState } from '@paragon/popup-state';
import { setMonitorForTaskSpinners } from '@paragon/task-spinner';

const monitor = new Monitor();

monitor.appendMetadata({ client: 'design' });

setMonitorForNotificationTools(monitor);
setMonitorForPopupState(monitor);
setMonitorForTaskSpinners(monitor);

export function getAppMonitor() {
  return monitor;
}

export function useAppMonitor(metadata: Metadata = null) {
  return useMemo(() => monitor.scope(metadata), [metadata]);
}
